import { isPlatformServer } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { retry, throwError, TimeoutError, timer } from 'rxjs';

export const HTTP_RETRY_COUNT = 3;
export const HTTP_RETRY_BASE_DELAY_MS = 1000;

const isTransientError = (error: unknown): boolean => {
  if (error instanceof TimeoutError) {
    return true;
  }

  if (error instanceof HttpErrorResponse) {
    return error.status === 0 || error.status === 429 || error.status >= 500;
  }

  return false;
};

export const retryInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.method !== 'GET' || isPlatformServer(inject(PLATFORM_ID))) {
    return next(request);
  }

  return next(request).pipe(
    retry({
      count: HTTP_RETRY_COUNT,
      delay: (error: unknown, retryCount: number) => {
        if (!isTransientError(error)) {
          return throwError(() => error);
        }

        return timer(HTTP_RETRY_BASE_DELAY_MS * 2 ** (retryCount - 1));
      },
    }),
  );
};
